import { render, staticRenderFns } from "./TabPayments.vue?vue&type=template&id=be5c0de2&"
import script from "./TabPayments.vue?vue&type=script&lang=js&"
export * from "./TabPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports